import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import AuthorHistoryModal from '../modals/AuthorHistoryModal';

class AuthorHistoryPortal extends Component {
  render() {

    // Container ref
    const targetContainer = document.getElementById('react-author-history');
    
    // Dont load if container doesnt exist
    if (targetContainer === null){
        return null;
    }

    return ReactDOM.createPortal(
        <AuthorHistoryModal />, targetContainer
    );
  }
}

export default AuthorHistoryPortal;